/**
 * @ngdoc service
 * @name cfn.unitConverter
 * @description
 * # unitConverter
 * Converts amounts between different units
 */
angular.module('cfn').factory('unitConverter', unitConverter);

function unitConverter() {
  function toObject(array) {
    var result = {};
    angular.forEach(array, function(item) {
      result[item] = true;
    });
    return result;
  }

  //can we generate this?
  var UNITS = {
    MASS_G: { factor: 0.001 },
    MASS_OUNCE: { factor: 0.02835, onlyInCountries: toObject(['GBR']) },
    MASS_KG: { factor: 1 },
    MASS_DT: { factor: 100 },
    MASS_T: { factor: 1000 },
    MASS_LB: { factor: 0.4536, onlyInCountries: toObject(['GBR']) },
    MASS_TON: { factor: 1016, onlyInCountries: toObject(['GBR']) },
    LIQUID_ML: { factor: 0.001 },
    LIQUID_DL: { factor: 0.1 },
    LIQUID_PINT: { factor: 0.5683, onlyInCountries: toObject(['GBR']) },
    LIQUID_L: { factor: 1 },
    LIQUID_HL: { factor: 100 },
    LIQUID_GAL: { factor: 4.546, onlyInCountries: toObject(['GBR']) },
    VOLUME_M3: { factor: 1000 },
    AREAL_HA: { factor: 1, decimals: 2 },
    AREAL_QM: { factor: 0.0001, decimals: 0 },
    AREAL_ACRE: { factor: 0.4074, decimals: 2 },
    QUANTITY_PIECE: { factor: 1, order: 3 },
    QUANTITY_GRAIN: { factor: 1, order: 2 },
    QUANTITY_UNIT: { factor: 1, order: 1 }
  };

  //these units are defined to be better that what we can compute when converting per area units
  var PER_AREA_UNITS_EXCEPTIONS = {
    'AREAL_HA->AREAL_QM': {
      MASS_DT: 'MASS_KG'
    }
  };

  var DEFAULT_DECIMALS = 2,
    IS_RATIO_RE = new RegExp(/.+PER.+_.+PER.+/);

  //prepare units
  (function() {
    var orderedNames = Object.keys(UNITS).sort(function(name1, name2) {
      if (UNITS[name1].order && UNITS[name2].order) {
        return UNITS[name1].order - UNITS[name2].order;
      } else {
        return UNITS[name1].factor - UNITS[name2].factor;
      }
    });
    var position = 0;
    for (var i in orderedNames) {
      var unit = UNITS[orderedNames[i]];
      unit.name = orderedNames[i];
      unit.order = position++;
      unit.group = (orderedNames[i] || '').split('_')[0];
    }
  })();

  /**
   * New Exception for unsupported units
   */
  function ConverterError(unit, message, cause) {
    this.unit = unit;
    if (message) {
      this.message = message;
    } else {
      this.message = 'Unit not supported: ' + unit;
    }
    if (cause) {
      this.cause = cause;
    }
  }
  ConverterError.prototype = new Error();
  ConverterError.prototype.constructor = ConverterError;

  /** Get unit corresponding group, i.e. MASS, VOLUME, LIQUID... */
  function getGroup(unit) {
    if (UNITS[unit]) {
      return UNITS[unit].group;
    } else {
      return (unit || '').split('_')[0];
    }
  }

  function isMass(unit) {
    return getGroup(unit) === 'MASS';
  }

  function isArea(unit) {
    return getGroup(unit) === 'AREAL';
  }

  function isUnitQuantity(unit) {
    return getGroup(unit) === 'QUANTITY';
  }

  function isVolumeGroup(group) {
    return ['LIQUID', 'VOLUME'].indexOf(group) !== -1;
  }

  function isVolume(unit) {
    return isVolumeGroup(getGroup(unit));
  }

  function isCapacityGroup(group) {
    return ['LIQUID', 'MASS', 'VOLUME'].indexOf(group) !== -1;
  }
  function isCapacity(unit) {
    return isCapacityGroup(getGroup(unit));
  }

  function isRatio(unit) {
    var group = getGroup(unit);
    return group && group.split('PER').length === 2;
  }

  /**
   * Converts given unit to kg
   *
   * @param {string} unitFrom unit of value
   * @param {number} value value to convert
   * @param {number} densityKgPerL density of the substance in kg/l
   */
  function anyToKg(unitFrom, value, densityKgPerL) {
    if (!UNITS[unitFrom]) {
      throw new ConverterError(unitFrom);
    }

    if (isMass(unitFrom)) {
      return value * UNITS[unitFrom].factor;
    } else {
      densityKgPerL = densityKgPerL || 1;
      var valueInUnitTimesKgPerL = value * densityKgPerL;
      return valueInUnitTimesKgPerL * UNITS[unitFrom].factor;
    }
  }

  /**
   * Converts kg to given unit
   *
   * @param {string} unitTo unit to convert to
   * @param {number} value value to convert in kg
   * @param {number} densityKgPerL density of the substance in kg/l
   */
  function kgToAny(unitTo, valueInKg, densityKgPerL) {
    if (!UNITS[unitTo]) {
      throw new ConverterError(unitTo);
    }

    if (isMass(unitTo)) {
      return valueInKg / UNITS[unitTo].factor;
    } else {
      densityKgPerL = densityKgPerL || 1;
      var valueInUnitTimesKgPerL = valueInKg / densityKgPerL;
      return valueInUnitTimesKgPerL / UNITS[unitTo].factor;
    }
  }

  /**
   * Converts a given areal unit to ha
   *
   * @param {value} area value to convert
   * @param {string} unitFrom to convert from
   */
  function anyToHectare(value, unitFrom) {
    if (!UNITS[unitFrom] || !isArea(unitFrom)) {
      throw new ConverterError(unitFrom);
    }
    return value * UNITS[unitFrom].factor;
  }

  /**
   * Converts an areal in ha to a given unit
   *
   * @param {value} area value to convert in ha
   * @param {string} unitTo to convert to
   */
  function hectarToAny(value, unitTo) {
    if (!UNITS[unitTo] || !isArea(unitTo)) {
      throw new ConverterError(unitTo);
    }
    return value / UNITS[unitTo].factor;
  }

  /**
   * Splits a ratio into numerator and denominator, if both can be converted
   * to capacity units. Returns an object containing fields .numerator and .denominator.
   *
   * @param {string} ratioUnit unit depicted in a ratio (e.g. KG/T)
   */
  function splitRatio(ratioUnit) {
    var unitNumerator = null,
      unitDenominator = null;
    if (ratioUnit && ratioUnit.split('_').length === 2) {
      var tmp = ratioUnit.split('_');
      var unitsTypes = tmp[0].split('PER');
      var unitsUnits = tmp[1].split('PER');
      unitNumerator = unitsTypes[0] + '_' + unitsUnits[0];
      unitDenominator = unitsTypes[1] + '_' + unitsUnits[1];
    }
    switch (ratioUnit) {
      case 'MASSPERMASS_GPERKG':
        // g/kg = kg/t (MASS_G nicht vorhanden)
        unitNumerator = 'MASS_KG';
        unitDenominator = 'MASS_T';
        break;
      case 'PERCENTAGE_PC':
        // KG/DT=0.01 (i.e. 1% is equivalent to 1kg/dt)
        unitNumerator = 'MASS_KG';
        unitDenominator = 'MASS_DT';
        break;
      case 'MASSPERVOLUMIC_KGPERCM':
        unitNumerator = 'MASS_KG';
        unitDenominator = 'VOLUME_M3';
        break;
      case 'MASSPERAREAL_KG_CPERHA':
        unitNumerator = 'MASS_KG';
        unitDenominator = 'AREAL_HA';
        break;
      case 'MASSPERAREAL_KG_CPERQM':
        unitNumerator = 'MASS_KG';
        unitDenominator = 'AREAL_QM';
        break;
    }

    if (unitNumerator === null || unitDenominator === null)
      throw new ConverterError(ratioUnit);
    return {
      numerator: unitNumerator,
      denominator: unitDenominator
    };
  }

  /**
   * joins a nominator and a denominator unit into a ratio unit (e.g. MASS_KG, VOLUME_L -> MASSPERVOLUME_KGPERL)
   * @param {string} numeratorUnit
   * @param {string} denominatorUnit
   * @returns {string}
   */
  function joinRatio(numeratorUnit, denominatorUnit) {
    try {
      var numeratorParts = numeratorUnit.split('_'),
        denominatorParts = denominatorUnit.split('_');

      var numeratorType = numeratorParts[0],
        numeratorUnit = numeratorParts[1],
        denominatorType = denominatorParts[0],
        denominatorUnit = denominatorParts[1];

      return (
        numeratorType +
        'PER' +
        denominatorType +
        '_' +
        numeratorUnit +
        'PER' +
        denominatorUnit
      );
    } catch (e) {
      throw new ConverterError(
        [numeratorUnit, denominatorUnit],
        'Cannot convert ratio unit from: numerator=' +
          numeratorUnit +
          '; denominator=' +
          denominatorUnit,
        e
      );
    }
  }

  /**
   * @param unit unit to check if it's a ratio unit
   */
  function isRatio(unit) {
    return IS_RATIO_RE.test(unit);
  }

  function isDirectlyConvertible(unitFrom, unitTo) {
    var groupFrom = getGroup(unitFrom);
    var groupTo = getGroup(unitTo);

    return groupFrom === groupTo || (isVolume(unitFrom) && isVolume(unitTo));
  }

  function convertCapacity(unitFrom, unitTo, value, densityKgPerL) {
    if (unitFrom === undefined || unitTo === undefined || value === undefined) {
      throw new Error('required parameter missing');
    }

    if (unitFrom === unitTo) {
      return value;
    }

    if (isDirectlyConvertible(unitFrom, unitTo)) {
      //no conversion is necessary
      var factorFrom = UNITS[unitFrom] && UNITS[unitFrom].factor;
      var factorTo = UNITS[unitTo] && UNITS[unitTo].factor;
      if (factorFrom && factorTo) {
        //go to base unit and from there to target
        return value * factorFrom / factorTo;
      } //else do as before
    }

    var valueInKg;

    // 1. Convert to kg
    valueInKg = anyToKg(unitFrom, value, densityKgPerL);

    // 2. Convert to destination unit
    return kgToAny(unitTo, valueInKg, densityKgPerL);
  }

  /**
   * Converts an areal value between two given units
   *
   * @param {string} unitFrom to convert from
   * @param {string} unitTo to convert to
   * @param {number} value area to convert
   */
  function convertArea(unitFrom, unitTo, value) {
    return hectarToAny(anyToHectare(value, unitFrom), unitTo);
  }

  /**
   * Converts one unit into another if possible.
   * @param {string} unitFrom unit of value
   * @param {string} unitTo unit to convert to
   * @param {number} value value to convert
   * @param {number} densityKgPerL density of the substance in kg/l (optional)
   */
  function convertAny(unitFrom, unitTo, value, densityKgPerL) {
    if (unitFrom === unitTo) return value;

    var errorCause;

    if (isArea(unitFrom) && isArea(unitTo)) {
      return convertArea(unitFrom, unitTo, value);
    } else if (isCapacity(unitFrom) && isCapacity(unitTo)) {
      return convertCapacity(unitFrom, unitTo, value, densityKgPerL);
    } else if (isRatio(unitFrom) && isRatio(unitTo)) {
      var unitsFrom = splitRatio(unitFrom);
      var unitsTo = splitRatio(unitTo);
      try {
        var newNumerator = convertAny(
          unitsFrom.numerator,
          unitsTo.numerator,
          value
        );
        var newDenominator = convertAny(
          unitsFrom.denominator,
          unitsTo.denominator,
          1
        );
        return newNumerator / newDenominator;
      } catch (e) {
        errorCause = e;
      }
    }

    throw new ConverterError(
      [unitFrom, unitTo],
      'Cannot convert unit ' + unitFrom + ' to ' + unitTo,
      errorCause
    );
  }

  function isForCountry(unitName, countryIsoName) {
    if (angular.isString(countryIsoName)) {
      var unit = UNITS[unitName];
      return (
        !unit ||
        !unit.onlyInCountries ||
        unit.onlyInCountries[countryIsoName] === true
      );
    }
  }

  function getUnitsInGroup(group, countryIsoName) {
    var isVolume = isVolumeGroup(group);
    return _.chain(UNITS)
      .filter(function(unit) {
        var isVisible = countryIsoName
          ? isForCountry(unit.name, countryIsoName)
          : true;
        return (
          (isVisible && unit.group === group) ||
          (isVolumeGroup(unit.group) && isVolume)
        );
      })
      .value();
  }

  function nextMatchingUnit(unit, factor, countryIsoName) {
    var bestMatch = UNITS[unit];

    if (bestMatch) {
      if (factor !== 1) {
        //compute the absolute factor to look for (i.e. in relation to our standard unit)
        var factor = bestMatch.factor * factor;

        var diff = Math.abs(bestMatch.factor - factor);
        _.each(getUnitsInGroup(getGroup(unit), countryIsoName), function(
          similarUnit
        ) {
          if (Math.abs(similarUnit.factor - factor) < diff) {
            //better match found
            bestMatch = similarUnit;
            diff = Math.abs(bestMatch.factor - factor);
          }
        });
      }
      return bestMatch.name;
    } else {
      return unit;
    }
  }

  function unitForPerAreaUnitConversion(
    sourceUnit,
    sourceAreaUnit,
    targetAreaUnit,
    countryIsoName
  ) {
    var key = sourceAreaUnit + '->' + targetAreaUnit;
    var convertException = (PER_AREA_UNITS_EXCEPTIONS[key] || {})[sourceUnit];
    if (convertException) return convertException;

    //no exception found, look for best match
    var areaFactor = convertAny(sourceAreaUnit, targetAreaUnit, 1);
    return nextMatchingUnit(sourceUnit, 1 / areaFactor, countryIsoName);
  }
  
  /**
   * Finds the smallest (min = true) or largest (min = false) unit of the given list. You may compare different types of units
   * though it makes no sense.
   *
   * @param {[string]} unitList list of units
   * @param {boolean} min true for the smallest or false for the largest possible unit
   */
  function minOrMax(unitList, min) {
    if (unitList && unitList.constructor === Array) {
      let next = null;
      for (let i in unitList) {
        let unit = UNITS[unitList[i]];
        if (unit && (next === null || (min ? unit.order < next.order : unit.order > next.order))) {
          next = unit;
        }
      }
      if (next !== null) {
        return next.name;
      }
    }
    // not sure what this is, give it back
    return unitList;
  }

  // Public
  return {
    /**
     * Finds the best unit if the sourceUnit per area is converted to some other area unit.
     * (sourceUnit/sourceAreaUnit -> ?/targetAreaUnit )
     * E.g: kg/ha -> ?/m2 returns g, which closely resembles the factor convertion for 1/ha->1/m2)
     *
     * @param {string} sourceUnit the enum name of the unit to be converted
     * @param {string} sourceAreaUnit the area unit for the source unit
     * @param {string} targetAreaUnit the area unit the result is going to be convered to
     */
    unitForPerAreaUnitConversion: unitForPerAreaUnitConversion,
    /**
     * Converts between two UnitsCapacityEnum / UnitsMassOrVolumeEnum, using the density if necessary.
     *
     * @param {string} unitFrom unit of value
     * @param {string} unitTo unit to convert to
     * @param {number} value value to convert
     * @param {number} densityKgPerL density of the substance in kg/l
     */
    convertCapacity: convertCapacity,

    /**
     * Converts an areal value between two given units
     *
     * @param {string} unitFrom to convert from
     * @param {string} unitTo to convert to
     * @param {number} value area to convert
     */
    convertArea: convertArea,

    /**
     * Converts one unit into another if possible.
     * @param {string} unitFrom unit of value
     * @param {string} unitTo unit to convert to
     * @param {number} value value to convert
     * @param {number} densityKgPerL density of the substance in kg/l (optional)
     */
    convert: convertAny,

    /**
     * @return if the given string represents a ratio (e.g. MASSPERMASS_KGPERT)
     */
    isRatio: isRatio,

    /**
     * Splits a ratio into numerator and denominator, if both can be converted
     * to capacity units. Returns an object containing fields .numerator and .denominator.
     *
     * @param {string} ratioUnit unit depicted in a ratio (e.g. KG/T)
     */
    splitRatio: splitRatio,

    /**
     * joins a nominator and a denominator unit into a ratio unit (e.g. MASS_KG, VOLUME_L -> MASSPERVOLUME_KGPERL)
     * @param {string} numeratorUnit
     * @param {string} denominatorUnit
     * @returns {string}
     */
    joinRatio: joinRatio,

    /**
     * Return the default decimal places to be shown for the given unit.
     * @param {string} unit of value (e.g. 'AREAL_HA')
     */
    unitDefaultDecimals: function(unit) {
      if (UNITS[unit] && UNITS[unit].decimals !== undefined) {
        return UNITS[unit].decimals;
      }
      return DEFAULT_DECIMALS;
    },

    /**
     * Calculates the amount of a nutrient that has been applied to a field. Returns kg/ha
     *
     * @param {Object} amount total amount applied to the field in amountUnit
     * @param {Object} amountUnit unit of the applied amount
     * @param {Object} nutrientAmount amount of the nutrient in the substance in nutrientAmountUnit
     * @param {Object} nutrientAmountUnit unit of the nutrient amount
     * @param {Object} densityKgPerL density of the substance in kg/l
     * @param {Object} area size of the area in areaUnit
     * @param {Object} areaUnit unit of the area, e.g. AREAL_HA
     */
    calculateNutrientFromAmount: function(
      amount,
      amountUnit,
      nutrientAmount,
      nutrientAmountUnit,
      densityKgPerL,
      area,
      areaUnit
    ) {
      var splitNutrientUnit,
        amountInNutrientUnit,
        nutrientAmountInNutrientUnit,
        nutrientAmountInKg,
        areaInHa,
        extraFactor = 1;

      switch (nutrientAmountUnit) {
        // Some units can be converted immediatelly
        case 'MASSPERAREAL_KG_CPERHA':
        case 'MASSPERAREAL_KGPERHA':
          // Unit is already kg/ha
          return nutrientAmount;
        case 'MASSPERAREAL_MGPERQM':
          // 1 mg/m² = 0.01 kg/ha
          return nutrientAmount / 100;
        case 'MASSPERAREAL_TPERHA':
          return nutrientAmount * 1000;
        case 'MASSPERLIQUID_LBPER1000GAL':
          splitNutrientUnit = {
            numerator: 'MASS_LB',
            denominator: 'LIQUID_GAL'
          };
          extraFactor = 0.001; // 1 / 1000 GAL
          break;
        // Other units need to be examined first
        default:
          splitNutrientUnit = splitRatio(nutrientAmountUnit);
          break;
      }

      // Normieren, damit mit Nenner der Nährstoff-Einheit kompatibel
      amountInNutrientUnit = this.convertCapacity(
        amountUnit,
        splitNutrientUnit.denominator,
        amount,
        densityKgPerL
      );

      // Nährstoffeinheit
      nutrientAmountInNutrientUnit = amountInNutrientUnit * nutrientAmount;
      // kg
      nutrientAmountInKg = this.convertCapacity(
        splitNutrientUnit.numerator,
        'MASS_KG',
        nutrientAmountInNutrientUnit,
        null
      );
      areaInHa = this.convertArea(areaUnit, 'AREAL_HA', area);
      // kg / ha
      return nutrientAmountInKg / areaInHa * extraFactor;
    },

    /**
     * Calculates the amount of a fertilizer required to achieve a given amount of nutrient on a field.
     *
     * @param {Object} appliedNutrientAmountKgPerHa nutrient amount applied per ha
     * @param {Object} amountUnit unit in which the resulting amount is expected
     * @param {Object} nutrientAmount amount of the nutrient in the substance in nutrientAmountUnit
     * @param {Object} nutrientAmountUnit unit of the nutrient amount
     * @param {Object} densityKgPerL density of the substance in kg/l
     * @param {Object} area size of the area in areaUnit
     * @param {Object} areaUnit unit of the area, e.g. AREAL_HA
     */
    calculateAmountFromNutrient: function(
      appliedNutrientAmountKgPerHa,
      amountUnit,
      nutrientAmount,
      nutrientAmountUnit,
      densityKgPerL,
      area,
      areaUnit
    ) {
      var splitNutrientUnit,
        appliedNutrientAmountInKg,
        appliedNutrientAmountInNumerator,
        appliedAmountInDenominator,
        extraFactor = 1;

      switch (nutrientAmountUnit) {
        // Some units can be converted immediatelly
        case 'MASSPERAREAL_KG_CPERHA':
        case 'MASSPERAREAL_KGPERHA':
          // Target unit is also kg/ha
          return appliedNutrientAmountKgPerHa;
        case 'MASSPERAREAL_MGPERQM':
          // 1 mg/m² = 0.01 kg/ha
          return appliedNutrientAmountKgPerHa * 100;
        case 'MASSPERAREAL_TPERHA':
          return appliedNutrientAmountKgPerHa / 1000;
        case 'MASSPERLIQUID_LBPER1000GAL':
          splitNutrientUnit = {
            numerator: 'MASS_LB',
            denominator: 'LIQUID_GAL'
          };
          extraFactor = 1000; //  1000 GAL
          break;
        // Other units need to be examined first
        default:
          splitNutrientUnit = splitRatio(nutrientAmountUnit);
          break;
      }

      // kg/ha * area -> kg
      appliedNutrientAmountInKg =
        appliedNutrientAmountKgPerHa *
        this.convertArea(areaUnit, 'AREAL_HA', area);
      // kg -> numerator unit
      // density is not needed because nutrient numerator units are also always MASS
      appliedNutrientAmountInNumerator = this.convertCapacity(
        'MASS_KG',
        splitNutrientUnit.numerator,
        appliedNutrientAmountInKg,
        null
      );
      // calculate amount
      appliedAmountInDenominator =
        appliedNutrientAmountInNumerator / nutrientAmount;
      // denominator unit to actual amount unit
      return (
        this.convertCapacity(
          splitNutrientUnit.denominator,
          amountUnit,
          appliedAmountInDenominator,
          densityKgPerL
        ) * extraFactor
      );
    },

    /**
     * Get the Group-Part of the unit (MASS / LIQUID / VOLUME / QUANTITY)
     * @param {STRING} unit e.g. "LIQUID_L" -> "LIQUID"
     */
    getGroup: function(unit) {
      return getGroup(unit);
    },

    /**
     * Checks if unit is defining volumes
     * @param {STRING} unit e.g. "LIQUID_L" -> true / "MASS_KG" -> false
     */
    isVolume: isVolume,

    /**
     * Checks if unit is a convertable capacity
     * @param {STRING} unit e.g. "LIQUID_L" -> true / "MASS_KG" -> true
     */
    isCapacity: isCapacity,
    /**
     * @param unit unit to check
     * @returns {boolean} if is a unit quantity e.g. "LIQUID_L" -> false / "QUANTITY_PIECE" -> true
     */
    isUnitQuantity: isUnitQuantity,

    /**
     * If the unit is of type mass.
     * @param {STRING} unit e.g. "LIQUID_L" -> false / "MASS_KG" -> true
     */
    isMass: isMass,

    /**
     * If the unit is of type Area.
     * @param {STRING} unit e.g. "LIQUID_L" -> false / "AREAL_HA" -> true
     */
    isArea: isArea,
    
    /**
     * @see minOrMax
     */
    min: function(unitList) {
      return minOrMax(unitList, true);
    },
    
    /**
     * @see minOrMax
     */
    max: function(unitList) {
      return minOrMax(unitList, false);
    },

    /**
     * @param unitName some unit name
     * @param country some country iso name (e.g. 'DEU')
     * @returns {bool} if the unit is available for this country
     */
    isForCountry: isForCountry,

    /**
     *
     * @param unitsArray an array with units names (e.g. [MASS_LB, MASS_KG, MASS_XXX)
     * @param country some country iso name (e.g. 'DEU')
     * @returns {*} the list of units that are accepted for this country (e.g. [MASS_KG, MASS_XXX])
     */
    unitsForCountry: function(unitsArray, countryIsoName) {
      if (angular.isArray(unitsArray) && angular.isString(countryIsoName)) {
        var filteredUnits = [];
        angular.forEach(unitsArray, function(unitName) {
          if (isForCountry(unitName, countryIsoName)) {
            filteredUnits.push(unitName);
          }
        });
        return filteredUnits;
      } else {
        return unitsArray;
      }
    },
    
    isGrain:function(unit) {
      return unit && 'QUANTITY_GRAIN' === unit;  
    }
  };
}

export default unitConverter;
